import { registerRoot, Composition } from 'remotion';
import { RewindEffect } from './RewindEffect';

const FPS = 30;

// This is the main component that holds all your compositions
export const RemotionRoot: React.FC = () => {
	return (
		<>
			<Composition
				id="RewindEffect"
				component={RewindEffect}
				durationInFrames={7 * FPS}
				fps={FPS}
				width={1024}
				height={1024}
			/>
		</>
	);
};

// This is the crucial line that was missing.
// It tells Remotion to use RemotionRoot as the entry point.
registerRoot(RemotionRoot);